import { render, staticRenderFns } from "./StatsInfos.vue?vue&type=template&id=b7cf822e&scoped=true&"
import script from "./StatsInfos.vue?vue&type=script&lang=js&"
export * from "./StatsInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cf822e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7cf822e')) {
      api.createRecord('b7cf822e', component.options)
    } else {
      api.reload('b7cf822e', component.options)
    }
    module.hot.accept("./StatsInfos.vue?vue&type=template&id=b7cf822e&scoped=true&", function () {
      api.rerender('b7cf822e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/LockerRoom/SubPages/Includes/StatsInfos.vue"
export default component.exports